import { Button } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
import UploadIcon from '../../icons/UploadIcon/UploadIcon';
const UploadButton = ({ children, ...rest }) => {
    const tokens = useTokens();
    return (React.createElement(Button, { leftIcon: React.createElement(UploadIcon, { "data-testid": "upload_icon", fill: tokens.ButtonSecondaryIcon }), variant: "secondary", maxHeight: "48px", minHeight: "48px", minW: "96px", p: "12px", ...rest }, children));
};
export default UploadButton;
